<template>
  <div class="address_wp">
    <AddressEdit
        :area-list="areaList"
        show-search-result
        :detail-rows="2"
        :search-result="[]"
        :area-columns-placeholder="['请选择', '请选择', '请选择']"
        save-button-text="确认兑换"
        @save="onSave"
    >
      <template>
        <Field
            v-model="message"
            type="textarea"
            :autosize="{ minHeight: 100 }"
            name="remark"
            label="留言"
            placeholder="如果有留言请在这里填写"
        >
        </Field>
        <Field
            v-model="bakMobile"
            name="bakMobile"
            label="备用电话（选填）"
            placeholder="备用电话"
        >
        </Field>
      </template>
    </AddressEdit>
  </div>
</template>

<script>
import axios from 'axios'
import {AddressEdit, Dialog, Field, Toast} from 'vant'
import { areaList } from '@vant/area-data';
import store from "../store";
import config from "../config";
export default {
  name: "Address",
  components: {
    AddressEdit,
    Field
  },
  data() {
    return{
      areaList,
      message: '',
      bakMobile: '',
      sharedStore: store.state
    }
  },
  methods: {
    onSave(values) {
      const { province, city, county, tel, name, addressDetail } = values
      const { token } = this.sharedStore
      axios.post(`${config.publicPath}/exchange-api/api/order`, {
            productId: this.$route.query.id,
            name,
            mobile: tel,
            bakMobile: this.bakMobile,
            address: province + city + county,
            detailAddress: addressDetail,
            remark: this.message
          },
          {
            headers: {
              "token": token
            }
          }
      ).then(res => {
        const { code, data, msg } = res.data
        if (code === 0) {
          Dialog.confirm({
            title: '兑换成功',
            message: '您提交的订单已经收到，我们将尽快为您安排发货，请您耐心等待，谢谢您的选择！',
            theme: 'round-button',
            confirmButtonText: '我知道了',
            confirmButtonColor: '#1989fa',
            showCancelButton: false,
            beforeClose: (action, done) => {
              this.$router.push({
                name: 'Home'
              })
              done()
            }
          })
        } else {
          Toast.fail(msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.address_wp {
  margin-top: 20px;
}

</style>